var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm._v(" WELCOME , " + _vm._s(_vm.$store.getters.userInfo.name) + " "),
      _c(
        "BjDivider",
        [
          _c("b", [_vm._v("User Manual and Video Tutorial")]),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.tryCancel()
                    },
                  },
                },
                [_vm._v("Download User Manual")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("BjStatusTabs", {
        attrs: {
          value: _vm.queryParamsTradeStatus,
          "option-list": _vm.TAB_LIST,
        },
        on: { handleTabClick: _vm.handleTabClick },
      }),
      _c("div", { staticClass: "maxbox" }, [
        _c("div", { staticClass: "flexBox" }, [
          _c("div", { staticClass: "textBox" }, [_vm._v("默认")]),
          _c("div", { staticClass: "videoBox" }, [
            _c("video", { attrs: { controls: "controls" } }, [
              _c("source", { attrs: { src: _vm.src } }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "flexBox" }, [
          _c("div", { staticClass: "textBox" }, [_vm._v("自定义")]),
          _c("div", { staticClass: "videoBox" }, [
            _c(
              "video",
              {
                attrs: { controls: "controls", width: "100%", height: "100%" },
              },
              [_c("source", { attrs: { src: _vm.src1 } })]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }